export const Language = {
    en: 'en',
    en_us: 'en-us',
    de: 'de',
    fr: 'fr',
    kk: 'kk',
    ru: 'ru',
    tr: 'tr',
} as const;
export type Language = (typeof Language)[keyof typeof Language];

export class Localization<T> {
    constructor(
        public lang: Language,
        public defaultLang: boolean,
        public data: T
    ) {}
}

export class TranslatableString {
    constructor(
        public data?: string,
        public lang?: string
    ) {
        this.data = data ? data : null;
        this.lang = lang ? lang : null;
    }
}
